import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ErrorPage from './ErrorPage';
import useTryAgainErrorButton from './useTryAgainErrorButton';

const reloadPage = () => window.location.reload();

const OfflineErrorPage = () => {
  const { t } = useTranslation();
  const tryAgainErrorButton = useTryAgainErrorButton(reloadPage);
  const buttons = useMemo(() => [tryAgainErrorButton], [tryAgainErrorButton]);
  return (
    <ErrorPage
      title={t('network-offline-page.title', 'Sorry, it appears you may have a connection issue.')}
      message={t('network-offline-page.heading', 'Network error')}
      buttons={buttons}
    />
  );
};

export default OfflineErrorPage;
